<template>
    <div>
        <base-header type="gradient-info" class="pb-6 pb-8 pt-5 pt-md-8">
            <div class="row mb-2">
                <div class="col-12 col-md-6 col-lg-6 col-xl-6">
                    <h1 class="text-white pt-3">รายงานใบแจ้งหนี้ / ใบเสร็จรับเงิน</h1>
                    <p class="text-white">สรุปรายงานใบแจ้งหนี้และใบเสร็จรับเงินทั้งหมด</p>
                </div>
                <template>
                    <div class="col-12 col-md-6 col-lg-6 col-xl-6 d-flex justify-content-end align-items-center" v-if="!this.$USER_LOGIN.get().isAdmin && reportInvoice.tabKey == 'INVOICE'">
                        <div class="btn-export-new">
                            <ExportExcel 
                                :columns="fieldExport[reportInvoice.tabKey]" 
                                :getData="getReportExcel"
                                name="ใบแจ้งหนี้-ใบเสร็จ "
                                :titleBtn="'Export'"
                            >
                            </ExportExcel>
                        </div>
                    </div>
                </template>
            </div>
            <CardTotalInvoice 
                v-if="!this.$USER_LOGIN.get().isAdmin && reportInvoice.tabKey == 'INVOICE'"
                :reportInvoice="reportInvoice"
            />
        </base-header>
        <div class="text-center" v-if="reportInvoice.busy">
            <BlockUI>
                <div class="loader"></div>
            </BlockUI>
        </div>
        <div class="container-fluid mt--8 mb-5">
            <div class="row">
                <div class="col">
                    <div class="card shadow" v-if="this.$USER_LOGIN.get().isShippop">
                        <SearchInvoice 
                            :search="search" 
                            :type="'INVOICE'"
                            @getReport="getReport"
                        />
                        <TableInvoice :search="search" :type="'INVOICE'" :reportInvoice="reportInvoice" @getReport="getReport"/>
                    </div>
                    <div class="tab-report" v-else-if="this.$USER_LOGIN.get().isSuperadmin">
                        <b-tabs>
                            <b-tab v-for="tab in listTab" :key="tab.key" :title="tab.name" @click="changeTab(tab.key)">
                                <SearchInvoice 
                                    :search="search" 
                                    :type="tab.key"
                                    @getReport="getReport"
                                />
                                <TableInvoice :search="search" :type="tab.key" :reportInvoice="reportInvoice" @getReport="getReport"/>
                            </b-tab>
                        </b-tabs>
                    </div>
                    <div class="card shadow" v-else-if="this.$USER_LOGIN.get().isAdmin">
                        <SearchInvoice 
                            :search="search" 
                            :type="'INVOICE_SELF'"
                            @getReport="getReport"
                        />
                        <TableInvoice :search="search" :type="'INVOICE_SELF'" :reportInvoice="reportInvoice" @getReport="getReport"/>
                    </div>
                </div>
            </div>
        </div>
        <ModalConfirmPayInvoice :modalPay="reportInvoice.modalPay" @getReport="getReport"/>
    </div>
</template>

<script>
import moment from "moment";
import { getReportInvoice , getReportInvoiceForExcel } from '@/axios/invoice'
import ExportExcel from '@/components/custom/exportExcel/ExportExcel'
import { fieldExport } from '@/components/custom/reportInvoice/fieldExcelInvoice'
import CardTotalInvoice from '@/components/custom/reportInvoice/CardTotalInvoice'
import SearchInvoice from '@/components/custom/reportInvoice/SearchInvoice'
import TableInvoice from '@/components/custom/reportInvoice/TableInvoice'
import { showErrorModal } from "@/components/modalNotification.js";
import ModalConfirmPayInvoice from '@/components/Modals/ModalConfirmPayInvoice'

export default {
    name: "reportinvoice",
    components:{
        CardTotalInvoice,
        SearchInvoice,
        TableInvoice,
        ModalConfirmPayInvoice,
        ExportExcel
    },
    data(){
        return{
            fieldExport: fieldExport,
            reportInvoice:{
                busy: true,
                listReportInvoice: [],
                listTotalInvoice: [],
                tabKey: (this.$USER_LOGIN.get().isSuperadmin) ? "INVOICE_SELF" : "INVOICE",
                isLoadingExcel: false,
                modalPay:{
                    show: false,
                    invoice: [],
                    type: null,
                    isLoading: false,
                    datePaid: null
                }
            },
            tabIndex: 0,
            search:{
                isLoading: false,
                date:{
                    startDate: moment().subtract(1, 'months').format("YYYY-MM-DD"),
                    endDate: moment().format("YYYY-MM-DD"),
                },
                shopCode: null,
                saCode: null,
                invoiceNo: null,
                receiptNo: null,
                status: null,
                paymentType: null,
                type: (this.$USER_LOGIN.get().isSuperadmin) ? 'superadmin' : null,
                totalPage: 1,
                totalItem: 0,
                page: 1,
                perPage: 25,
            }
        }
    },
    mounted() {
        this.defaultLoad()
    },
    methods: {
        defaultLoad(){    
            this.getReport();
        },        
        getReport(){
            this.search.isLoading = true;

            getReportInvoice(this.search).then( res => {
                this.reportInvoice.listReportInvoice = res.item;
                this.reportInvoice.listTotalInvoice = res.total_invoices;
                this.search.totalPage = res.total_page
                this.search.totalItem = res.total_item
                this.search.page = res.page
                this.reportInvoice.busy = false;
                this.search.isLoading = false;
            }).catch( error => {
                this.reportInvoice.busy = false;
                this.search.isLoading = false;
                showErrorModal( error )
            })
        },
        async getReportExcel(){
            return await getReportInvoiceForExcel( this.search );
        },
        changeTab( tabKey ){
            this.reportInvoice.tabKey = tabKey

            if(this.$USER_LOGIN.get().isSuperadmin ){
                if( this.reportInvoice.tabKey == 'INVOICE' ){
                    this.search.type = 'shop'
                }else{
                    this.search.type = 'superadmin'
                }
            }

            this.getReport()
        }
    },
    computed:{
        listTab(){
            return  [
                ...( this.$USER_LOGIN.get().isSuperadmin ) 
                ? [
                    { key:'INVOICE_SELF', name:'ใบแจ้งหนี้/ใบเสร็จรับเงินของฉัน' },
                    { key:'INVOICE', name:'ใบแจ้งหนี้/ใบเสร็จรับเงินร้านค้า' },
                    // { key:'RECEIPT', name:'รายงานใบเสร็จรับเงิน' },
                ]
                : []
                
            ]
        },
    }
}

</script>